export default __webpack_public_path__ + "static/media/FOTO3.477f66ea.jpg";